import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBestBuyPair, useBestBuyInputAmount, useBestBuyUserConfig } from "../../../../state/dex/hooks";
import { InputAmountStatus, useMinMaxAmountVerify } from "../../hooks/useTradeVerify";
import { formatNumber } from "../../../../utils/numbers";
import { LOCALES } from "../../../../locales";
import { StyledContainer, StyledTitle, StyledRateInfoWrapper, StyledRateInfoText, StyledOrderInfoWrapper, StyledWarningInfoWrapper, StyledWarningUl, StyledMainContainer, StyledTriggerPrice } from "./styled";
import { useNetworkValidator } from "../../../../hooks";

var PreviewInfo = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var isZh = i18n.resolvedLanguage === LOCALES.ZH;

  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 2),
      inputToken = _useBestBuyPair2[0],
      outputToken = _useBestBuyPair2[1];

  var _useBestBuyInputAmoun = useBestBuyInputAmount(),
      inputAmount = _useBestBuyInputAmoun.inputAmount;

  var _useBestBuyUserConfig = useBestBuyUserConfig(),
      expiration = _useBestBuyUserConfig.expiration,
      rate = _useBestBuyUserConfig.rate;

  var _expiration$split = expiration.split('_'),
      _expiration$split2 = _slicedToArray(_expiration$split, 2),
      expirationValue = _expiration$split2[0],
      expirationUnit = _expiration$split2[1];

  var verifyMinMaxAmount = useMinMaxAmountVerify();

  var _useNetworkValidator = useNetworkValidator(),
      isArbitrum = _useNetworkValidator.isArbitrum;

  var minAmount = isArbitrum ? 10 : 100;

  var _useState = useState(InputAmountStatus.DEFAULT),
      status = _useState[0],
      setStatus = _useState[1];

  useEffect(() => {
    if (inputAmount === '') return setStatus(InputAmountStatus.DEFAULT);
    var minMaxResult = verifyMinMaxAmount(inputAmount, expirationValue);
    setStatus(minMaxResult);
  }, [inputAmount, expirationValue]);
  return __jsx(StyledContainer, null, __jsx(StyledMainContainer, null, __jsx(StyledTitle, null, t('best_buy_preview_box_title')), __jsx(StyledRateInfoWrapper, null, __jsx("div", null, isZh ? __jsx("div", null, __jsx(StyledTriggerPrice, null, "1 ".concat(outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol, " \u2264 ").concat(formatNumber(rate), " \n                  ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)), t('best_buy_preview_box_buy_when')) : __jsx("div", null, t('best_buy_preview_box_buy_when'), __jsx(StyledTriggerPrice, null, "1 ".concat(outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol, " \u2264 ").concat(formatNumber(rate), " \n                  ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)))), __jsx(StyledRateInfoText, null, t('best_buy_preview_box_desc'))), __jsx(StyledOrderInfoWrapper, null, __jsx("li", null, t('best_buy_preview_box_info_duration', {
    expirationValue,
    expirationUnit: isZh ? t('days') : expirationUnit
  })), __jsx("li", null, t('best_buy_preview_box_info_fee')), __jsx("li", null, t('best_buy_preview_box_info_budget', {
    amount: formatNumber(inputAmount),
    token: inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol
  })), __jsx("li", null, t('best_buy_preview_box_info_other')))), status === InputAmountStatus.MIN_AMOUNT_ERROR && __jsx(StyledWarningInfoWrapper, null, t('best_buy_verify_min_amount_error', {
    amount: minAmount
  }), __jsx(StyledWarningUl, null, __jsx("li", null, t('best_buy_verify_min_amount_error_tip_1')), __jsx("li", null, t('best_buy_verify_min_amount_error_tip_2')))));
};

export default PreviewInfo;